import initShortCourseHero from './components/short-courses-hero';
import initShortCourseHover from './components/short-courses-hover';

const ticker = document.querySelector('.js-ticker');

if (ticker) {
    initShortCourseHero(ticker);
}

const shortCourseHover = document.querySelector('.js-lfw-hover');

if (shortCourseHover) {
    initShortCourseHover(shortCourseHover);
}
